import id from './id/id.json';

export default id;
